const wrapper = document.querySelector('.menu-media__wrapper');
const scrollEl = wrapper?.querySelector('.main-menu-media');

if (!wrapper || !scrollEl) return;

function updateScrollState() {
  const { scrollLeft, scrollWidth, clientWidth } = scrollEl;
  const atStart = scrollLeft <= 1;
  const atEnd = scrollLeft + clientWidth >= scrollWidth - 1;

  wrapper.classList.toggle('is-at-start', atStart);
  wrapper.classList.toggle('is-at-end', atEnd);
}

scrollEl.addEventListener('scroll', updateScrollState);
window.addEventListener('resize', updateScrollState);
updateScrollState();